import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFormsByPersonId } from "api";
import { selectPersonId } from "reducers/securitySlice";

export const fetchLeaveManager = createAsyncThunk(
	"leaveManager/fetchLeaveManager",
	//need the thunkApi's getState to retrieve auth token
	async (_, { getState, rejectWithValue, dispatch }) => {
		try {
			const state = getState();
			const personId = selectPersonId(state);
			const data = await getFormsByPersonId({ personId });
			dispatch(leaveManagerReceived(data));
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const initialState = {
	status: "idle",
	error: null,
	data: [],
};

const leaveManagerSlice = createSlice({
	name: "leaveManager",
	initialState,
	reducers: {
		leaveManagerReceived(state, action) {
			state.data = [...action.payload];
		},
	},
	extraReducers: {
		[fetchLeaveManager.pending]: (state, action) => {
			state.status = "loading";
			state.error = null;
		},
		[fetchLeaveManager.fulfilled]: (state, action) => {
			state.status = "idle";
			state.error = null;
		},
		[fetchLeaveManager.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
	},
});

export const { leaveManagerReceived } = leaveManagerSlice.actions;

export const selectLeaveManager = (state) => state.cme.leaveManager.data;
export const selectLeaveManagerStatus = (state) =>
	state.cme.leaveManager.status;
export const selectLeaveManagerError = (state) => state.cme.leaveManager.error;

export default leaveManagerSlice.reducer;
